import { render, staticRenderFns } from "./DlvN.vue?vue&type=template&id=68be2d6c"
import script from "./DlvN.vue?vue&type=script&lang=js"
export * from "./DlvN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports